import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import FetchService from "../../api/FetchService";
import "./SearchEdit.scss";
import {getAllActivityCategories} from "../../commons/activity-filters/Helpers"
import edit from "../../img/edit.png"

function ActivityPage({ setIsLoading }) {
  const [categories, setCategories] = useState(getAllActivityCategories());

  const navigate = useNavigate();

  const handleEdit = (label) =>{
      navigate('/aktivitet-side?cat=' + encodeURIComponent(label))
  }

  useEffect(() => {
      //fetchData();
      setCategories(categories.filter(category => category.value != "all" && category.value != "default" ))
  }, []);

  return (
      <div className="search_edit_main Register_page" >
          <h2 class="form_heading inner_header_main heading_filter_otr">Kategori favoritter</h2>
          <table>
              <thead class="table_header">
            <tr>
                  <th> <p class="heading-xmb header_text">Navn</p></th>
                  <th> <p class="heading-xmb header_text">Tiltak</p></th>
                  </tr>
            </thead>
            {
                categories.map((category)=>(
                    <tr>
                        <td >
                            <p class="heading-ms body_text">
                                {category.label.replace("Dagsevent", "Pa kontoret").replace("Julebord", "Firmafest")}
                            </p> 
                        </td>
                        <td > 

                            <div data-edit={category.value} onClick={() => handleEdit(category.value)} class="my-1 btn btn-primary-form center"><i class="ri-eye-line"></i>Vis/rediger</div>
                    </td>
                    </tr>
                ))
            }

        </table>
    </div>
  );
}

export default ActivityPage;
